export { SCOPES } from "@sentry/mcp-core/scopes";

export const NPM_PACKAGE_NAME = "@sentry/mcp-server";

export const NPM_REMOTE_NAME = "mcp-remote";
